/** Default-off tenant opt-in. Never consult a global row. */
export const ROSTER_APP_EVENTS_FLAG = 'roster_app_events_v1';
export function isTenantScopedRosterAppEventsFlag(key: string | null | undefined): boolean {
  return key === ROSTER_APP_EVENTS_FLAG;
}

import type { SupabaseClient } from '@supabase/supabase-js';
/** Shared browser/server resolution: exact tenant; missing or unreadable false. */
export async function loadRosterAppEventsEnabled(
  sb: SupabaseClient,
  tenantId?: string | null,
): Promise<boolean> {
  if (!tenantId) return false;
  try {
    const { data, error } = await sb
      .from('feature_flags')
      .select('enabled')
      .eq('tenant_id', tenantId)
      .eq('flag_key', ROSTER_APP_EVENTS_FLAG)
      .maybeSingle();
    return !error && data?.enabled === true;
  } catch {
    return false;
  }
}
